import { marked } from 'marked'
import { forwardRef, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Element } from '../../common/html/element'
import { Icon } from '../../common/html/icon'
import { ScrollComponent } from '../../common/scrollComponent'
import { USER_TYPE_CODE } from '../constants'
import { selectMessageTopic, selectTyping } from '../store/slice'
import TypingBubble from './TypingBubble'

const ContentChat = forwardRef((props, ref) => {
  const messageTopic = useSelector(selectMessageTopic)
  const typing = useSelector(selectTyping)

  const [isAutoScroll, setIsAutoScroll] = useState(true)

  const handleScroll = () => {
    if (!ref.current) return
    const { scrollTop, scrollHeight, clientHeight } = ref.current.view
    const isAtBottom = scrollHeight - scrollTop - clientHeight < 50
    setIsAutoScroll(isAtBottom)
  }

  const formatText = (rawText) => {
    marked.setOptions({
      breaks: true,
      gfm: true,
    })

    const html = marked.parse(rawText || '')

    // Bọc tất cả các bảng trong một thẻ div
    const wrappedHtml = html.replace(/<table([\s\S]*?)<\/table>/g, (match) => {
      return `<div class="table-wrapper">${match}</div>`
    })

    return wrappedHtml
  }

  useEffect(() => {
    const viewEl = ref.current?.view
    if (!viewEl) return

    const handleWheel = (e) => {
      if (e.deltaY < 0) {
        setIsAutoScroll(false)
      }
    }

    viewEl.addEventListener('scroll', handleScroll)
    viewEl.addEventListener('wheel', handleWheel, { passive: true })

    return () => {
      viewEl.removeEventListener('scroll', handleScroll)
      viewEl.removeEventListener('wheel', handleWheel)
    }
  }, [])

  return (
    <ScrollComponent scrollbarsRef={ref}>
      <div className="messages-list">
        {messageTopic.map((m) => (
          <div
            key={m.messageId}
            className={`message ${
              m.userTypeCode === USER_TYPE_CODE.USER ? 'user' : 'ai'
            } ${m.isError ? 'error' : ''}`}
          >
            <div className="bubble">
              {m.userTypeCode === USER_TYPE_CODE.USER ? (
                <>
                  {m.ask || m?.quoteContent?.length ? (
                    <div className="ask-quote">
                      <div className="ask-quote-label">
                        <Icon
                          className="icon-reply"
                          style={{ fontSize: 20, color: '#9C9C9C' }}
                        />
                        <Element style={{ fontSize: 14 }}>
                          "{m.ask || m?.quoteContent[0]?.quoteText}"
                        </Element>
                      </div>
                    </div>
                  ) : null}
                  <Element
                    className="content-user-chat"
                    style={{ fontSize: 14 }}
                  >
                    {m.content}
                  </Element>
                </>
              ) : (
                <>
                  {m.messageId === typing.messageId && !typing.done ? (
                    <TypingBubble
                      key={m.messageId}
                      text={m.content}
                      scrollRef={ref}
                      isAutoScroll={isAutoScroll}
                      formatText={formatText}
                    />
                  ) : (
                    <Element
                      className="content-ai-chat"
                      style={{ fontSize: 14 }}
                      dangerouslySetInnerHTML={{
                        __html: formatText(m.content),
                      }}
                    />
                  )}
                </>
              )}
            </div>
          </div>
        ))}
      </div>
    </ScrollComponent>
  )
})

export default ContentChat
